// Rodolfo Rivas
// 2017
// *************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
// *************************************************************//


import {Component, HostListener, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LogEmisor} from './recursos/modelo/LogEmisor';
import * as moment from 'moment';
import {BsDatepickerConfig, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {FormControl, FormGroup} from '@angular/forms';
import {isNullOrUndefined} from 'util';

import {MatChipInputEvent, MatSnackBar} from '@angular/material';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Ng2DeviceService} from 'ng2-device-detector';
import {AmazingTimePickerService} from 'amazing-time-picker';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {MatPaginator} from '@angular/material/paginator';
import {ConsumerService} from '../../../../recursos/servicio/consumer.service';
import {LayoutService} from '../../../../recursos/servicio/layout.service';
import {UtilConfig} from '../../../../../autenticacion/servicios/UtilConfig';
import {WebServices} from '../../../../recursos/modelo/consumerModel/web-services.enum';
import {Emisor} from '../../../seguridad/emisor/recursos/modelo/emisor';
import {Lote} from '../cmp-list-documents/recursos/modelo/Lote';
import {parseInt} from 'lodash';
import {CustomUrlSerializer} from '../../../../recursos/modelo/UrlSerializer/custom-url-serializer';

declare var swal: any;

declare const $: any;


@Component({
    moduleId: module.id,
    selector: 'app-listDetalleLote',
    templateUrl: './view/list-detalleLote.component.html',
    styleUrls: ['./css/list-detalleLote.component.scss'],
    providers: [ConsumerService]
})
export class ListDetalleLoteComponent implements OnInit, OnChanges {
    // ITEM DEL CRUD
    origenCRUD = 'documento';

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─

    PENDING = 'PENDING';
    todos = false;
    mensaje = '<i class=\'material-icons\'>search</i> REALICE SU BUSQUEDA UTILIZANDO LOS FILTROS';
    loading = false;
    noHayResultados = false;
    es;
    cargandoConsulta = false;
    cargandoList = false;
    applicationType: any[] = [];
    applications: any[] = [];
    familyType: any[] = [];
    families: any[] = [];
    form: FormGroup;
    searchField: FormControl;
    searchField2: FormControl;
    emisor: Emisor = new Emisor();
    poseeEmisorDocumentos = false;
    empresaAdministradora = false;
    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_LOTE_TERCERO_CONSULTAR: false,
        ROLE_LOTE_TERCERO_LEVEL_1: false,
        ROLE_LOTE_TERCERO_LEVEL_2: false,
        ROLE_LOTE_TERCERO_APROBAR: false,
        ROLE_LOTE_TERCERO_GENERAR: false,
        ROLE_LOTE_TERCERO_COMPLETAR: false,
    };
    //variables modelo
    ItemLista: any[];
    verDetalle = false;
    ItemSelected: LogEmisor;
    logSeleccionado = new LogEmisor();
    logSeleccionadoEstado = 1;
    locale = 'es';
    colorTheme = 'theme-dark-blue';
    bsConfig: Partial<BsDatepickerConfig>;
    // scroll list
    scrollItems: LogEmisor[] = [];
    readonly bufferSize = 50;
    timer: any;
    loadingTexto = false;
    loadingTextoRefinir = false;
    totalRegistros = 0;
    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;

    // Enter, comma
    separatorKeysCodes = [ENTER, COMMA];
    correosReenvio = [];
    selectedMovil = false;
    init = true;

    lote: Lote;
    idLote;
    type;
    displayedColumns: string[];
    dataSource?: any;
    level1: false;
    level2: false;
    selection = new SelectionModel<any>(true, []);
    @ViewChild(MatPaginator) paginator: MatPaginator;

    rangeDates: Date = new Date();
    private colorText = null;
    private colorTitle = null;

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this.dataSource.data.forEach(row => this.selection.select(row));
    }

    applyFilter(filter) {
        let filterValue = filter.target.value;
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

    /**
     * Set the paginator after the view init since this component will
     * be able to query its view for the initialized paginator.
     */
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        // this.paginator._intl.itemsPerPageLabel = 'Documentos por paginas ';
    }

    constructor(private consumer: ConsumerService,
                private route: ActivatedRoute,
                private router: Router,
                private layout: LayoutService,
                private snackBar: MatSnackBar,
                public jwtUtil: UtilConfig,
                private _localeService: BsLocaleService,
                private deviceService: Ng2DeviceService,
                private atp: AmazingTimePickerService) {

        this._localeService.use(this.locale);
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);
        this.emisor = jwtUtil.getCurrentUser().customer;
        this.applicationType = [];
        this.familyType = [];

        this.ItemLista = [];

        this.bsConfig = Object.assign({}, {
            containerClass: this.colorTheme,
            showWeekNumbers: false,
            dateInputFormat: 'YYYY-MM-DD'
        });

        const fechaIni = (new Date().getMonth() + 1) + '/01/' + new Date().getFullYear();
        this.es = jwtUtil.CONFIG_ES_CALENDAR;


        // SI LA EMPRESA ES ESCON SE HABILITAN LOS SELECT
        if (this.emisor.id == parseInt(jwtUtil.ESCON_CUSTOMER))
            this.empresaAdministradora = true;

        this.poseeEmisorDocumentos = this.jwtUtil.poseeEmisor();

        if (CustomUrlSerializer.decript(this.router.url).indexOf('ELECTRONIC') != -1) {
            this.type = 'ELECTRONIC';
        } else {
            this.type = 'PHYSICAL';
        }
        // VERIFICA LOS PERMISOS DEL LOG LOGEADO
        this.route.params.subscribe(params => {
            if (params['id']) {
                this.idLote = params['id'];
            }
            this.realizarBusqueda();
        });

        if (this.jwtUtil.getColorText()) {
            this.colorText = this.jwtUtil.getColorText();
        }
        this.layout.getColorText().subscribe(colorText => {
            this.colorText = colorText;
        });

        if (this.jwtUtil.getColorTitle()) {
            this.colorTitle = this.jwtUtil.getColorTitle();
        }
        this.layout.getColorTitle().subscribe(colorTitle => {
            this.colorTitle = colorTitle;
        });
    }

    @HostListener('window:keyup.escape', ['$event'])
    keyEvent(event: KeyboardEvent) {
        $('ul#slide-out').removeClass('open');
        $('i.cerrarAleta').removeClass('open');
        $.each(this.ItemLista, function (pos, item) {
            item.seleccionado = false;
        });
    }

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        // Add our fruit
        if ((value || '').trim() && this.validarEmail(value)) {
            this.correosReenvio.push(value.trim());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }
    }


    validarEmail(valor) {
        if (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(valor)) {
            console.log('La dirección de email ' + valor + ' es correcta!.');
            return true;
        } else {
            this.snackBar.open('La dirección de email es incorrecta!.', null, {duration: 2000});
            return false;
        }
    }

    remove(correo: any): void {
        const index = this.correosReenvio.indexOf(correo);

        if (index >= 0) {
            this.correosReenvio.splice(index, 1);
        }
    }


    ngOnChanges(changes: SimpleChanges) {

        if (this.jwtUtil.getColorTitle()) {
            this.colorTitle = this.jwtUtil.getColorTitle();
        }

        if (this.jwtUtil.getColorText()) {
            this.colorText = this.jwtUtil.getColorText();
        }
    }


    ngOnInit() {
        if (this.deviceService.isMobile() || this.deviceService.isTablet())
            this.selectedMovil = true;
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴


    refrescar() {
        this.realizarBusqueda();
    }


    obtenerIdSelection() {
        return this.selection.selected.map((task) => task.id);
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐

    cerrarDetalle() {
        $('ul#slide-out').removeClass('open');
        $('ul#slide-out').removeClass('openExtend');
        $('.detalleDocumento').addClass('oculto');
        $('i.cerrarAleta').removeClass('open');
        $('i.cerrarAleta').removeClass('openExtend');
        $.each(this.ItemLista, function (pos, log) {
            log.seleccionado = false;
        });
        this.logSeleccionado = new LogEmisor();
    };

    consulta(item) {
        if (item.seleccionado) {
            item.seleccionado = !item.seleccionado;
            $('ul#slide-out').removeClass('open');
            $('ul#slide-out').removeClass('openExtend');
            $('i.cerrarAleta').removeClass('open');
            $('.detalleDocumento').addClass('oculto');
            $('i.cerrarAleta').removeClass('openExtend');
            return false;
        }

        $.each(this.ItemLista, function (pos, log) {
            log.seleccionado = false;
        });

        $('ul#slide-out').addClass('open');
        $('i.cerrarAleta').addClass('open');
        this.correosReenvio = [];
        item.seleccionado = !item.seleccionado;
        this.logSeleccionado = new LogEmisor(null, '', '', '', '', '', '', '', '', '', '', [], '', '');
        this.cargandoConsulta = true;
        this.consumer.getById<any>('log', item.id, WebServices.URL_GET_LOG_EMISOR)
            .subscribe(result => {
                this.logSeleccionado = result['log'];
                this.logSeleccionado.fileName = this.logSeleccionado.fileName.replace('.zip', '');
                this.logSeleccionado.logEmailSend = result['logEmailResponse'];

                if (this.logSeleccionado.comprobantes != null && this.logSeleccionado.comprobantes.length > 0) {
                    this.logSeleccionadoEstado = this.logSeleccionado.comprobantes[0].indEstado;
                } else {
                    this.logSeleccionadoEstado = 3;
                }

                this.logSeleccionado.linkRequestPSE = null;
                if (this.logSeleccionado.pseRequest && !isNullOrUndefined(this.logSeleccionado.pseRequest.id))
                    this.logSeleccionado.linkRequestPSE = this.jwtUtil.URL_WS_BACKEND + WebServices.URL_GET_ARCHIVO_LOG_EMISOR + '?log.id=' + this.logSeleccionado.id + '&tipoDescarga=PSE&authorization=' + this.jwtUtil.getJwtToken();

                this.cargandoConsulta = false;
            }, err => {
                this.cargandoConsulta = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, 'No se pudo consultar el documento', this.router);
            });
    }

    getListNoSelected(): any[] {
        const list = [];
        const lista = this.ItemLista.filter(element => !this.selection.selected.includes(element));
        lista.forEach(value => {
            list.push(value.id);
        });
        return list;
    }

    guardarTemporal() {
        this.cargandoConsulta = true;
        const params = {
            'ids': this.getListNoSelected(),
            'loteId': parseInt(this.idLote),
            'rowType': this.type
        };
        this.consumer.post<any>(WebServices.URL_MARKED_EMISOR_TERCERO, params)
            .subscribe(result => {
                this.cargandoConsulta = false;
                this.regresar();
            }, err => {
                this.cargandoConsulta = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, 'No se pudo consultar el documento', this.router);
            });
    }

    questionSure(action: string) {
        if (action === 'LEVEL1') {
            swal({
                title: 'Estas seguro de aprobar el lote?',
                text: 'Una vez aprobado el lote, no lo podras modificar',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, estoy seguro!',
                cancelButtonText: 'No, espero',
                confirmButtonClass: 'btn btn-success',
                cancelButtonClass: 'btn btn-danger',
                buttonsStyling: false
            }).then(() => {
                this.aprobarLoteLevel1();
            }, function (dismiss) {
            }).catch(swal.noop);

        } else if (action == 'LEVEL2') {
            swal({
                title: 'Estas seguro de aprobar el lote?',
                text: 'Una vez aprobado el lote, no lo podras modificar',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, estoy seguro!',
                cancelButtonText: 'No, espero',
                confirmButtonClass: 'btn btn-success',
                cancelButtonClass: 'btn btn-danger',
                buttonsStyling: false
            }).then(() => {
                this.aprobarLoteLevel2();
            }, function (dismiss) {
            }).catch(swal.noop);

        } else if (action == 'GENERARLOTE') {
            swal({
                title: 'Estas seguro de generar el lote?',
                text: 'Una vez generado el lote, no se podra modificar',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, estoy seguro!',
                cancelButtonText: 'No, espero',
                confirmButtonClass: 'btn btn-success',
                cancelButtonClass: 'btn btn-danger',
                buttonsStyling: false
            }).then(() => {
                this.generarLote();
            }, function (dismiss) {
            }).catch(swal.noop);

        }

    }

    aprobarLoteLevel1() {
        this.aprobarLote(1);
    }

    aprobarLoteLevel2() {
        this.aprobarLote(2);
    }

    validateData() {
        const list = [];
        let valido = true;
        this.selection.selected.forEach(item => {
            if (item.serialNumber == '' || item.correlative == '' || item.bankAccountNumber == '' || item.expirationDate == '') {
                valido = false;
            }
        });
        return list;
    }

    aprobarLote(level) {
        this.cargandoConsulta = true;

        if (this.type === 'PHYSICAL') {
            if (!this.validateData()) {
                swal({
                    title: 'Error aprobando',
                    text: 'Se debe completar toda la información de los registros seleccionados',
                    type: 'error',
                    confirmButtonClass: 'btn btn-success',
                    buttonsStyling: false
                });
                return false;
            }
        }

        const params = {
            'ids': this.getListNoSelected(),
            'loteId': parseInt(this.idLote),
            'rowType': this.type,
            'level': level
        };
        this.consumer.post<any>(WebServices.URL_APPROVE_EMISOR_TERCERO, params)
            .subscribe(result => {
                this.cargandoConsulta = false;
                this.realizarBusqueda();
                this.regresar();
                swal({
                    title: 'Aprobado',
                    text: '',
                    type: 'success',
                    confirmButtonClass: 'btn btn-success',
                    buttonsStyling: false
                });
            }, err => {
                this.cargandoConsulta = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, 'No se pudo aprobar lote', this.router);
            });
    }

    generarLote() {
        this.cargandoList = true;
        const params = {
            'id': this.idLote,
            'rowType': this.type,
        };
        this.consumer.post<any>(WebServices.URL_GENERATE_EMISOR_TERCERO, params)
            .subscribe(result => {
                this.cargandoList = false;
                this.realizarBusqueda();
                this.regresar();
                swal({
                    title: 'En proceso',
                    text: 'Su lote se esta generando',
                    type: 'success',
                    confirmButtonClass: 'btn btn-success',
                    buttonsStyling: false
                });
            }, err => {
                this.cargandoList = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, 'No se pudo consultar el documento', this.router);
            });
    }


//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘
    private realizarBusqueda() {
        // LLAMADO AL SERVICIO
        $('ul#slide-out').removeClass('open');
        $('i.cerrarAleta').removeClass('open');
        this.cargandoList = true;
        const params = {
            id: this.idLote,
            rowType: this.type
        };
        this.consumer.post<any>(WebServices.URL_LIST_LOG_DETAILS_EMISOR_TERCERO, params)
            .subscribe(result => {
                this.cargandoList = false;
                this.ItemLista = result['thirdsDetail'];
                this.lote = result['batch'];
                this.ItemLista.map(item => {
                    item.documentType = this.transform(item.documentType);
                    item.processStatusTraducido = this.transformStatus(item.processStatus);
                    item.oseStatusTraducido = this.transformStatus(item.oseStatus);
                    item.paymentStatusTraducido = this.transformStatus(item.paymentStatus);
                });
                this.dataSource = new MatTableDataSource<any>(this.ItemLista);
                this.dataSource.paginator = this.paginator;
                if (this.ItemLista == null) {
                    this.ItemLista = [];
                    this.dataSource.data = [];
                }
                if ((this.ItemLista != null) && (this.ItemLista.length == 0)) {
                    this.mensaje = '<i class="material-icons">warning</i>HUBO UN PROBLEMA CARGANDO EL DETALLE DEL LOTE';
                }
                if (this.totalRegistros === 0 && this.ItemLista != null && this.ItemLista.length === 0) {
                    this.cargandoList = false;
                } else {
                    if (this.lote.status == this.PENDING &&
                        (
                            (this.validLevel1Approved() && this.authorities.ROLE_LOTE_TERCERO_LEVEL_1) ||
                            (this.validLevel2Approved() && this.authorities.ROLE_LOTE_TERCERO_LEVEL_2)
                        )) {
                        this.selection.clear();
                        this.ItemLista.forEach(value => {
                            if (value.marked) {
                                this.selection.select(value);
                            }
                            if (value.bankAccountType == undefined || value.bankAccountType == null) {
                                value.bankAccountType = 'CORRIENTE';
                            }
                            if (value.bankPaymentType == undefined || value.bankPaymentType == null) {
                                value.bankPaymentType = 'ABONO';
                            }
                        });
                        if (this.type === 'ELECTRONIC') {
                            this.displayedColumns = ['select', 'ruc', 'customer', 'documentType', 'document', 'igvType', 'totalAmount', 'processStatus', 'oseStatus', 'paymentStatus'];
                        }
                        if (this.type === 'PHYSICAL') {
                            this.displayedColumns = ['select', 'ruc', 'customer', 'documentType', 'serialNumber', 'correlative', 'bankAccountType', 'bankAccountNumber', 'bankPaymentType', 'expirationDate', 'totalAmount', 'processStatus', 'action'];
                        }
                    } else {
                        if (this.type === 'ELECTRONIC') {
                            this.displayedColumns = ['ruc', 'customer', 'documentType', 'document', 'igvType', 'totalAmount', 'processStatus', 'oseStatus', 'paymentStatus'];
                        }
                        if (this.type === 'PHYSICAL') {
                            this.displayedColumns = ['ruc', 'customer', 'documentType', 'serialNumber', 'correlative', 'bankAccountType', 'bankAccountNumber', 'bankPaymentType', 'expirationDate', 'totalAmount', 'processStatus'];
                        }
                    }
                }
            }, err => {
                this.ItemLista = [];
                this.dataSource.data = [];
                this.cargandoList = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, 'No se pudo consultar el documento', this.router);
            });
    }

    validLevel1Approved() {
        return (this.ItemLista.length > 0 && (this.ItemLista[0].level1IssueUsername == '' || this.ItemLista[0].level1IssueUsername == undefined));
    }

    validLevel2Approved() {
        return (this.ItemLista.length > 0 && (this.ItemLista[0].level2IssueUsername == '' || this.ItemLista[0].level2IssueUsername == undefined));
    }

    actualizarInfo(item) {
        item.loading = true;
        const params = {
            'id': item.id,
            'serialNumber': item.serialNumber,
            'correlative': parseInt(item.correlative),
            'bankAccountNumber': item.bankAccountNumber,
            'expirationDate': moment(item.expirationDate).format('YYYY-MM-DD'),
            'bankPaymentType': item.bankPaymentType,
            'bankAccountType': item.bankAccountType
        };
        this.consumer.post<any>(WebServices.URL_COMPLETED_EMISOR_TERCERO, params)
            .subscribe(result => {
                item.loading = false;
                item.marked = true;
                if (!this.selection.hasValue()) {
                    this.selection.toggle(item);
                }
            }, err => {
                item.loading = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, 'No se pudo consultar el documento', this.router);
            });
    }

    regresar() {
        history.back();
    }

    transform(input: any): any {
        switch (input) {
            case 'INVOICE':
            case '01':
                input = 'Factura';
                break;
            case 'TICKET':
            case '03':
                input = 'Boleta';
                break;
            case 'DEBIT_NOTE':
            case '08':
                input = 'Nota de Débito';
                break;
            case 'CREDIT_NOTE':
            case '07':
                input = 'Nota de Crédito';
                break;
            case 'PERCEPTION':
                input = 'Percepción';
                break;
            case 'RETENTION':
            case '20':
                input = 'Retención';
                break;
            case 'SUMMARY_DOCUMENT':
                input = 'Resumen Diario';
                break;
            case 'DESPATCH_ADVICE':
                input = 'Guía de Remisión';
                break;
            case 'DESPATCH_TRANSPORT':
                input = 'Guía Transportista';
                break;
            case 'RA_VOIDED_DOCUMENT':
                input = 'Comunicación de Baja';
                break;
            case 'RR_VOIDED_DOCUMENT':
                input = 'Resumen de Reversiones';
                break;
            case 'CORRUPTED_DOCUMENT':
                input = 'Documento Corrupto';
                break;
            case 'INVALID_DOCUMENT':
                input = 'Documento Invalido';
                break;
            case '-1':
                input = 'Todos';
                break;
        }


        return input;
    }

    transformStatus(input: any): any {
        switch (input) {
            case 'PENDING':
                input = 'PENDIENTE';
                break;
            case 'COMPLETED':
                input = 'COMPLETADO';
                break;
            case 'FAILED':
                input = 'NO APROBADO';
                break;
            case 'APPROVED':
                input = 'APROBADO';
                break;
            case 'IN_PROCESS':
                input = 'EN PROCESO';
                break;
            case 'PROCESSED':
                input = 'PROCESADO';
                break;
            case 'VALIDATED':
                input = 'VALIDADO';
                break;
            case 'REJECTED':
                input = 'RECHAZADO';
                break;
        }
        return input;
    }
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/emisorTerceros/cmp-list-detalle-lote/list-detalle-lote.component.ts